import React, { useEffect, useState } from "react";
import "./styles/heroes.css";
import "./styles/home.css";
import "./styles/mediaqueries.css";
import "./styles/items.css";
import axios from "axios";
import parse from "html-react-parser";
import Footer from "../components/Footer";
import filterBg from "../Assets/images/Hero_Sort_Bg.png";
import itemsFrame from "../Assets/images/Items_Frame.png";
import itemsFrameSelected from "../Assets/images/Hero_Skill_Hover_Select.png";
import filter1 from "../Assets/images/filter/Icon_CreepLevel_Minor.png";
import filter2 from "../Assets/images/filter/Icon_CreepLevel_Normal.png";
import filter3 from "../Assets/images/filter/Icon_CreepLevel_Major.png";
import filter4 from "../Assets/images/filter/Icon_CreepLevel_Super.png";
import filter5 from "../Assets/images/filter/Icon_CreepLevel_Ultra.png";
import filter6 from "../Assets/images/filter/Icon_CreepLevel_Boss.png";

const Monsters = () => {
  const [itemData, setItemData] = useState(null);
  const [items, setItems] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [selectedAbility, setSelectedAbility] = useState("");
  const [selectedItemIndex, setSelectedItemIndex] = useState({
    index: -1,
    itemName: "",
  });
  const [specificItemStatus, setSpecificItemStatus] = useState({
    isLoading: false,
    data: null,
  });
  const [showDetails, setShowDetails] = useState(isPhone() ? false : true);

  const filterItems = (attributeType) => {
    setSelectedAbility(attributeType);
    if (selectedAbility === attributeType) {
      setItems(itemData);
      setSelectedAbility("");
      return;
    }
    const filteredItems = itemData?.filter(
      (item) => item.creepTier == attributeType
    );
    setItems(filteredItems);
    setSelectedItemIndex({ index: 0, itemName: filteredItems[0]?.enum });
  };
  const itemHandler = (itemName, index) => {
    setShowDetails(true);
    setSelectedItemIndex({ index: index, itemName: itemName });
  };

  function formatDescription(description) {
    if (description) {
      let formattedDescription = description?.replace(
        /<#([a-fA-F0-9]{6})>/g,
        '<span style="color: #$1;">'
      );
      formattedDescription = formattedDescription.replace(
        /<\/color>/g,
        "</span>"
      );

      formattedDescription = formattedDescription.replace(/<u>/g, "<u>");
      formattedDescription = formattedDescription.replace(/<\/u>/g, "</u>");

      formattedDescription = formattedDescription.replace(
        /<link=\"{{[^}]*}}\">/g,
        ""
      );
      formattedDescription = formattedDescription.replace(/<\/link>/g, "");
      return formattedDescription;
    }
  }

  function isPhone() {
    const userAgent = navigator.userAgent.toLowerCase();
    return /iphone|ipod|android.*mobile|windows phone|blackberry|webos/.test(
      userAgent
    );
  }

  useEffect(() => {
    if (selectedItemIndex.index !== -1) {
      if (!selectedItemIndex.itemName) return;
      setSpecificItemStatus({ ...specificItemStatus, isLoading: true });
      axios
        .get(
          `https://cotp-game.azurewebsites.net/api/CombatEntity/GetSpecificByEnum?enumValue=${selectedItemIndex.itemName}`
        )
        .then((res) => {
          setSpecificItemStatus({ isLoading: false, data: res?.data });
        });
    }
  }, [selectedItemIndex]);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Roshpit Champions II | Monsters";
    axios
      .get("https://cotp-game.azurewebsites.net/api/CombatEntity/GetAll")
      .then((res) => {
        setItemData(res?.data);
        setItems(res?.data);
        !isPhone() &&
          setSelectedItemIndex({ index: 0, itemName: res?.data[0]?.enum });
      });
  }, []);

  useEffect(() => {
    setSelectedAbility("");
    if (searchValue.length > 0) {
      setItems(
        itemData?.filter((item) =>
          item.name?.toLowerCase().includes(searchValue.toLowerCase())
        )
      );
    } else {
      setItems(itemData);
    }
  }, [searchValue]);
  return (
    <>
      <div className="heroes">
        <div className="heroes_heading_container container">
          <div className="heroes_heading">
            <p>Monsters</p>
            <span>
              A vast array of fearsome creatures and relentless adversaries
              await champions brave enough to venture into the perilous world of
              Roshpit Champions II. Each monster presents unique challenges,
              testing heroes' strategies and strengths in multiple differrent
              ways. Cunning beasts and formidable horrors lurk in the shadows,
              and only those who master their foes can ascend to greatness.
            </span>
          </div>
        </div>
        <div className="search container">
          <div className="filter_wrapper">
            <img src={filterBg} alt="" srcset="" />
            <div className="filter_content">
              <p>Filters</p>
              <div className="filter_ability_icons">
                <img
                  src={filter1}
                  alt=""
                  srcset=""
                  className={`${selectedAbility == 1 ? "active_icon" : ""}`}
                  onClick={() => filterItems(1)}
                />
                <img
                  src={filter2}
                  alt=""
                  srcset=""
                  className={`${selectedAbility == 2 ? "active_icon" : ""}`}
                  onClick={() => filterItems(2)}
                />
                <img
                  src={filter3}
                  alt=""
                  srcset=""
                  className={`${selectedAbility == 3 ? "active_icon" : ""}`}
                  onClick={() => filterItems(3)}
                />
                <img
                  src={filter4}
                  alt=""
                  srcset=""
                  className={`${selectedAbility == 4 ? "active_icon" : ""}`}
                  onClick={() => filterItems(4)}
                />
                <img
                  src={filter5}
                  alt=""
                  srcset=""
                  className={`${selectedAbility == 5 ? "active_icon" : ""}`}
                  onClick={() => filterItems(5)}
                />
                <img
                  src={filter6}
                  alt=""
                  srcset=""
                  className={`${selectedAbility == 6 ? "active_icon" : ""}`}
                  onClick={() => filterItems(6)}
                />
              </div>
            </div>
          </div>
          <div className="search_wrapper">
            <input
              type="text"
              placeholder="SEARCH"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
            />
            <i className="bi bi-search"></i>
          </div>
        </div>
        {items?.length === 0 ? (
          <div
            style={{
              width: "100%",
              color: "#fff",
              display: "flex",
              justifyContent: "center",
              marginTop: "5rem",
              fontSize: "2rem",
            }}
          >
            <p className="gradient_heading">No Monster Found</p>
          </div>
        ) : (
          <div className="items_wrapper container">
            {showDetails && items?.length > 0 ? (
              <div className={`items_details`}>
                {specificItemStatus.isLoading ? (
                  <div className="items_details_loader">
                    <div className="lds-ripple">
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                ) : (
                  <div className="details_section">
                    <button
                      className="close_button"
                      onClick={() => setShowDetails(false)}
                    >
                      <i className="bi bi-x"></i>
                    </button>
                    <div className="details_top_section">
                      <div className="details_top_section_image item large">
                        <div className="item_img">
                          <img
                            src={specificItemStatus?.data?.portrait}
                            alt={specificItemStatus?.data?.name}
                          />
                        </div>
                      </div>
                      <div className="details_top_section_info">
                        <p className="details_top_section_info_name">
                          {specificItemStatus?.data?.name}
                        </p>
                        <p className="details_top_section_info_stat">
                          creep tier{" "}
                          <span>{specificItemStatus?.data?.creepTierName}</span>
                        </p>
                        <p className="details_top_section_info_stat">
                          id <span>{specificItemStatus?.data?.enum}</span>
                        </p>
                      </div>
                    </div>
                    {specificItemStatus?.data?.loreData ? (
                      <p className="details_top_section_description">
                        {specificItemStatus?.data?.loreData}
                      </p>
                    ) : null}
                    {specificItemStatus?.data?.hasSpecial ? (
                      <>
                        <div className="details_top_section_ability">
                          <p className="details_top_section_ability_key">
                            SPECIAL ABILITY
                          </p>
                          <p className="details_top_section_ability_value">
                            {specificItemStatus?.data?.itemSpecialName}
                          </p>
                        </div>
                        <p className="details_top_section_ability_description">
                          {parse(
                            formatDescription(
                              specificItemStatus?.data?.itemSpecialDescription
                            )
                          )}
                        </p>
                      </>
                    ) : null}
                    <table className="items_table">
                      <tr>
                        <th>Base Stats</th>
                        <th>Value</th>
                        {/* <th>max</th> */}
                      </tr>
                      <tr>
                        <td>Armor</td>
                        <td>{specificItemStatus?.data?.baseStats.armor}</td>
                        {/* <td>{specificItemStatus?.data?.max_ItemArmor}</td> */}
                      </tr>
                      <tr>
                        <td>Magic Armor</td>
                        <td>
                          {specificItemStatus?.data?.baseStats.magicArmor}
                        </td>
                        {/* <td>{specificItemStatus?.data?.max_ItemMagicArmor}</td> */}
                      </tr>
                      <tr>
                        <td>Armor Pierce</td>
                        <td>
                          {specificItemStatus?.data?.baseStats.armorPierce}
                        </td>
                        {/* <td>{specificItemStatus?.data?.max_ItemArmorPierce}</td> */}
                      </tr>
                      <tr>
                        <td>Spell Pierce</td>
                        <td>
                          {specificItemStatus?.data?.baseStats.spellPierce}
                        </td>
                        {/* <td>{specificItemStatus?.data?.max_ItemSpellPierce}</td> */}
                      </tr>
                      <tr>
                        <td>Mana</td>
                        <td>{specificItemStatus?.data?.baseStats.mana}</td>
                        {/* <td>{specificItemStatus?.data?.max_ItemSpellPierce}</td> */}
                      </tr>
                      <tr>
                        <td>Health</td>
                        <td>{specificItemStatus?.data?.baseStats.health}</td>
                        {/* <td>{specificItemStatus?.data?.max_ItemSpellPierce}</td> */}
                      </tr>
                    </table>
                    {/* <table className="items_table">
                      <tr>
                        <th>Possible Modifiers</th>
                        <th>min</th>
                        <th>max</th>
                      </tr>
                      {specificItemStatus?.data?.itemMods?.map((mod, index) => (
                        <tr key={index}>
                          <td>{mod.modName}</td>
                          <td>{mod.minValue}</td>
                          <td>{mod.maxValue}</td>
                        </tr>
                      ))}

                      <tr>
                        <td>Magic Armor</td>
                        <td>{specificItemStatus?.data?.min_ItemMagicArmor}</td>
                        <td>{specificItemStatus?.data?.max_ItemMagicArmor}</td>
                      </tr>
                      <tr>
                        <td>Armor Pierce</td>
                        <td>{specificItemStatus?.data?.min_ItemArmorPierce}</td>
                        <td>{specificItemStatus?.data?.max_ItemArmorPierce}</td>
                      </tr>
                      <tr>
                        <td>Spell Pierce</td>
                        <td>{specificItemStatus?.data?.min_ItemSpellPierce}</td>
                        <td>{specificItemStatus?.data?.max_ItemSpellPierce}</td>
                      </tr>
                    </table> */}
                  </div>
                )}
              </div>
            ) : null}
            <div className="heroes_container items">
              {items === null ? (
                <div className="video_overlay1">
                  <div className="lds-ripple">
                    <div></div>
                    <div></div>
                  </div>
                  <p>Loading Monsters...</p>
                </div>
              ) : (
                items?.map((item, index) => {
                  return (
                    //   <Link key={index} to={`/hero/${item.heroEnumValue}`}>
                    <div
                      key={index}
                      className="item"
                      onClick={() => itemHandler(item.enum, index)}
                    >
                      {selectedItemIndex.index == index ? (
                        <img
                          className="items_frame_selected"
                          src={itemsFrameSelected}
                          alt=""
                          srcset=""
                        />
                      ) : (
                        <img
                          className="items_frame"
                          src={itemsFrame}
                          alt=""
                          srcset=""
                        />
                      )}
                      {/* <img
                        src={heroFrame}
                        className="hero-frame"
                        alt=""
                        srcset=""
                      /> */}
                      <div className="item_img">
                        <img src={item.portrait} alt={item.name} />
                        {/* <div className="hero_details">
                        <p className="">{item.heroEnum}</p>
                        {getAbilityIcon(item.primaryAttribute)}
                      </div> */}
                      </div>
                      {/* <span>{item.itemName}</span> */}
                    </div>
                    //   </Link>
                  );
                })
              )}
            </div>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default Monsters;
